import { render, staticRenderFns } from "./BackupBalanceSwitch.vue?vue&type=template&id=f4be0450&scoped=true&"
import script from "./BackupBalanceSwitch.vue?vue&type=script&lang=js&"
export * from "./BackupBalanceSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BackupBalanceSwitch.vue?vue&type=style&index=0&id=f4be0450&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4be0450",
  null
  
)

export default component.exports